// extracted by mini-css-extract-plugin
export default {"cuadroDatos":"CuadroDatos_cuadroDatos__V5uWX","tituloCuadroDatos":"CuadroDatos_tituloCuadroDatos__-7K4E"};